import { setIsAuthenticated } from 'src/models/auth/slice';
import { clearCookies } from './queries';

export const logout = () => {
  clearCookies();
  localStorage.clear();
  setIsAuthenticated(false);

  window.location.replace('/');
};
